/**
 * Arcade games-list difficulty chip colours.
 * Text is paired with an opaque surface bg (#18181b, matching COLOR.surface /
 * MUI Paper) so axe does not composite through `transparent` against a lighter
 * elevated overlay. Ratios are WCAG 2.x relative luminance against #18181b
 * (and ≈#242426 elevated): all ≥ 4.5:1.
 *
 * Before (outline on transparent → elev paper):
 *   Medium #fbbf24 → often measured ~OK on flat surface but residual axe hits
 *     when elev/overlay lightens the effective bg; Hard #ef4743 ≈ 4.17 on elev.
 * After:
 *   Easy   #4ade80 on #18181b ≈ 9.4:1
 *   Medium #fde047 on #18181b ≈ 12.5:1  (was #fbbf24 outline)
 *   Hard   #f87171 on #18181b ≈ 5.6:1   (was #ef4743 ≈ 4.17 on elev)
 */
export const DIFFICULTY_CHIP_SURFACE = '#18181b';

export const DIFFICULTY_CHIP_COLORS = {
  easy: '#4ade80',
  medium: '#fde047',
  hard: '#f87171',
};

export function difficultyChipColor(difficulty) {
  const key = String(difficulty || '').trim().toLowerCase();
  return DIFFICULTY_CHIP_COLORS[key] || '#a1a1aa';
}

export function difficultyChipSx(difficulty) {
  const color = difficultyChipColor(difficulty);
  return {
    bgcolor: DIFFICULTY_CHIP_SURFACE,
    border: `1px solid ${color}`,
    color,
    fontWeight: 700,
    fontSize: '0.75rem',
  };
}

/** WCAG relative-luminance contrast ratio for two #rrggbb colours. */
export function contrastRatio(fg, bg) {
  const toLin = (c) => {
    const v = c / 255;
    return v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };
  const lum = (hex) => {
    const h = hex.replace('#', '');
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return 0.2126 * toLin(r) + 0.7152 * toLin(g) + 0.0722 * toLin(b);
  };
  const a = lum(fg);
  const b = lum(bg);
  const hi = Math.max(a, b);
  const lo = Math.min(a, b);
  return (hi + 0.05) / (lo + 0.05);
}
